import * as Mui from "@mui/material";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import { GenericTitleHeader } from "../component/common/GenericTitleHeader";
import EquipmentAssociationPage from "../component/equipmentAssociation/EquipmentAssociationPage";
import SectionHeader from "../../../util/component/SectionHeader";
import React from "react";

const EquipmentAssociation = () => {
  const {t} = useTranslation(["operation"]);
  return (
    <>
      <Mui.Box>
        <SectionHeader
            title={t("vehicleEquipmentAssociation.pageTitlePart1") + " " + t("vehicleEquipmentAssociation.pageTitlePart2")}
        />
        <Routes>
          <Route path="/" element={<EquipmentAssociationPage />} />
        </Routes>
      </Mui.Box>
    </>
  )
}

export default EquipmentAssociation;